module.exports = __webpack_public_path__ + "img/map-pin-bold.73e23936.svg";